
// header account
$('<span class="header__icon-text">SIGN IN</span>').insertAfter( $('.site-header .header__icon-group .header__individual-icon').find('#Icon_Account').parent() );
const interval = setInterval(function() {
    if ($('body').hasClass('customer-logged-in')) {
        $('.site-header .header__icon-group .header__individual-icon').find('#Icon_Account').parent().siblings('.header__icon-text').text('MY ACCOUNT');
        clearInterval(interval);
    }
}, 100);


// header search
if($('.site-header .header__search-container').length) {
    $('<span class="header__icon-text">SEARCH</span>').insertAfter( $('.site-header .header__search-container').find('#Icon_Search').parent() );
    $('.site-header .header__search-container').prependTo('.site-header .header__wrapper > .header-icons.large--text-right > .header__icon-group');
}


// header store
if($('.site-header .header__wrapper > .header-icons.large--text-right').length) {
  $('<div class="store-finder"><a class="country-selector" href="https://www.colehaan.com/international-landing.html" title="Select Country"><img src="https://cdn.shopify.com/s/files/1/0670/4939/0238/files/flag-th.png?v=1762220944" alt=""></a><a class="find-a-store" href="https://colehaanthailand.myshopify.com/pages/store-locator" title="STORES">STORES</a></div>').insertBefore('.site-header .header__wrapper > .header-icons.large--text-right');
}
if($('#NavDrawer .mobile__nav-wrapper > .mobile__nav-links').length) {
  $('<div class="store-finder"><a class="find-a-store" href="https://colehaanthailand.myshopify.com/pages/store-locator" title="Find a store">Find a store</a></div>').prependTo('#NavDrawer .mobile__nav-wrapper > .mobile__nav-links');
  $('<div class="country"><a class="country-selector" href="https://www.colehaan.com/international-landing.html" title="Select Country">STORES<br><img src="https://cdn.shopify.com/s/files/1/0670/4939/0238/files/flag-th.png?v=1762220944" alt=""></a></div>').appendTo('#NavDrawer .mobile__nav-wrapper > .mobile__nav-links');
}

// Main Slideshow Video
(function ensurePlaysInlineForSectionVideos(window, document) {
  function apply(el) {
    if (!(el instanceof HTMLVideoElement)) return;
    if (!el.classList.contains("video-section__video")) return;

    el.setAttribute("playsinline", "");
    el.setAttribute("webkit-playsinline", "");
    el.playsInline = true;
    if (el.autoplay && !el.muted) el.muted = true;
  }

  // Initial pass
  document.querySelectorAll("video.video-section__video").forEach(apply);

  // Watch for dynamically inserted videos
  const mo = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((n) => {
        if (n.nodeType !== 1) return;
        if (n.matches?.("video.video-section__video")) apply(n);
        n.querySelectorAll?.("video.video-section__video").forEach(apply);
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})(window, document);

// Products
(function () {
  var ROOT = '.featured-collection';
  var VP = '.flickity-viewport';

  function updateAll() {
    $(ROOT).find(VP).each(function () {
      var $vp = $(this), $s = $vp.find('.flickity-slider').first();
      var h = 0;
      $s.children().each(function () {
        var r = this.getBoundingClientRect();
        if (r.height > h) h = Math.ceil(r.height);
      });
      if (h) $vp.height(h);
    });
  }

  function watch() {
    var root = document.querySelector(ROOT);
    if (!root) return;
    var mo = new MutationObserver(function () { updateAll(); });
    mo.observe(root, { childList: true, subtree: true });
  }

  $(function () {
    updateAll();
    watch();

    $(window).on('resize', function () {
      updateAll();
      setTimeout(updateAll, 300);
    });

    $(window).on('load', function () {
      updateAll();
      [200, 500, 1000, 2000].forEach(function (t) {
        setTimeout(updateAll, t);
      });
    });

    ['shopify:section:load','shopify:section:select','shopify:block:select']
      .forEach(function (e) {
        document.addEventListener(e, function () {
          updateAll();
          setTimeout(updateAll, 300);
        }, { passive: true });
      });
  });
})();

// Collections
(function () {
  var ROOT_SEL = '.homepage-collection-wrapper,[data-section-type="collection"]';
  var ITEM_SEL = '.collection-grid__content-wrapper';

  function init(root){
    if (root.querySelector('.flickity-enabled')) return;
    var items = root.querySelectorAll(ITEM_SEL);
    if (!items.length) return;

    var gap = document.createElement('div');
    gap.className = 'custom-collection-slider-gap';
    root.prepend(gap);

    var slider = document.createElement('div');
    slider.className = 'custom-collection-slider';
    // root.prepend(slider);
    gap.insertAdjacentElement('afterend', slider);
    items.forEach(el => slider.appendChild(el));

    $(slider).flickity({
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 75,
        y2: 35,
        x3: 40
      },
      accessibility: true,
      cellSelector: ITEM_SEL,
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: false,
      freeScrollFriction: 0.075,
      friction: 0.28,
      namespaceJQueryEvents: true,
      percentPosition: true,
      resize: true,
      selectedAttraction: 0.025,
      adaptiveHeight: true,
    });
  }

  function scan(){
    document.querySelectorAll(ROOT_SEL).forEach(init);
  }

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
})();

// Collection Template
(function () {
  function moveHeader() {
    const main = document.querySelector('main');
    if (!main) return;

    const header = main.querySelector('.collection-header');
    if (!header) return;

    const target = main.querySelector('.section__collection-list, .section__gallery');
    if (!target) return;

    if (target.compareDocumentPosition(header) & Node.DOCUMENT_POSITION_FOLLOWING) {
      target.parentNode.insertBefore(header, target);
    }
  }

  document.addEventListener('DOMContentLoaded', moveHeader);
  document.addEventListener('shopify:section:load', moveHeader);

})();

// Gallery
(function () {
  function checkGallery() {
    document.querySelectorAll('.gallery__wrapper').forEach(function (wrap) {
      const hasMedia = wrap.querySelector('img, video');
      const parent = wrap.parentElement;

      if (hasMedia) {
        wrap.classList.remove('no-media');
        if (parent) parent.classList.remove('no-media');
      } else {
        wrap.classList.add('no-media');
        if (parent) parent.classList.add('no-media');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', checkGallery);
  window.addEventListener('load', checkGallery);
  document.addEventListener('shopify:section:load', checkGallery);

  const observer = new MutationObserver(checkGallery);
  observer.observe(document.body, { childList: true, subtree: true });
})();

// Single Product
document.addEventListener("DOMContentLoaded", function () {
  var container = document.querySelector(".product-template__container");
  if (!container) return;

  var meta = container.querySelector(".product__meta");
  var imageContainer = container.querySelector(".product__image-container");
  if (!meta || !imageContainer) return;

  if (container.querySelector(".product__meta--clone")) return;

  var title = meta.querySelector(".h1");
  var price = meta.querySelector('[id^="price-template"]');
  var tax = meta.querySelector(".product__tax");

  var clone = document.createElement("div");
  clone.className = "product__meta product__meta--clone";
  clone.setAttribute("data-cloned", "true");

  if (title) clone.appendChild(title.cloneNode(true));
  if (price) clone.appendChild(price.cloneNode(true));
  if (tax) clone.appendChild(tax.cloneNode(true));

  clone.querySelectorAll("[id]").forEach(function (el) {
    el.removeAttribute("id");
  });
  clone.querySelectorAll('[role="status"], [aria-live]').forEach(function (el) {
    el.setAttribute("aria-hidden", "true");
  });

  container.insertBefore(clone, imageContainer);
});

// // Newsletter
// document.addEventListener("DOMContentLoaded", function () {
//   var newsletter = document.querySelector(".footer__newsletter");
//   if (!newsletter) return;

//   var desc = newsletter.querySelector(".footer__description");
//   var form = newsletter.querySelector(".loft-form__container");
//   if (!desc || !form) return;

//   form.insertAdjacentElement("afterend", desc);
// });